import styled from "styled-components";
import About from "./About";
import Hero from "./Hero";
import Footer from "./Footer";
import ProjectTwo from "./portfolio/ProjectTwo";

const Home = () => {
	return (
		<ScrollContainer>
			<HeroContainer>
				<Hero />
			</HeroContainer>
			<AboutMeContainer>
				<About />
			</AboutMeContainer>
			<ProjectContainer>
				<ProjectTwo />
			</ProjectContainer>
			<ContactContainer>
				<Footer />
			</ContactContainer>
		</ScrollContainer>
	);
};

export default Home;

const ScrollContainer = styled.div``;

const HeroContainer = styled.section`
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const AboutMeContainer = styled.section`
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const ContactContainer = styled.section``;

const ProjectContainer = styled.div``;
